import SrPronounce from './SrPronounce';

export default SrPronounce;



// WEBPACK FOOTER //
// ./lib/index.ts